/* eslint-disable import/no-cycle */
import * as types from './types';
import { initialState } from './index';

const mutations = {
  [types.SET_SELECTED_FILTER]: (state, payload) => {
    state.selectedFilters[payload.filter] = payload.value;
  },
  [types.SET_SELECTED_ADVERTISER_DETAILS]: (state, payload) => {
    state.selectedAdvertiserDetails = payload;
  },
  [types.RESET_STORE]: (state) => {
    Object.assign(state, initialState());
  },
};
export default mutations;
